/**
 * @generated SignedSource<<54692ffc61c2a415c8dfded1e2b7e913>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ClientSortBy = "DATE_ADDED_ASC" | "DATE_ADDED_DESC" | "LAST_ACTIVE_ASC" | "LAST_ACTIVE_DESC" | "NAME_ASC" | "NAME_DESC" | "PROGRAM_END_ASC" | "PROGRAM_END_DESC" | "PROGRESS_ASC" | "PROGRESS_DESC" | "%future added value";
export type ClientStatusFilter = "ACTIVE" | "ADDED" | "ARCHIVED" | "PENDING" | "%future added value";
export type CoachClientsListScreenRefetchQuery$variables = {
  after?: string | null | undefined;
  first?: number | null | undefined;
  includeAllClients?: boolean | null | undefined;
  query?: string | null | undefined;
  sort: ClientSortBy;
  status?: ReadonlyArray<ClientStatusFilter> | null | undefined;
  tagId?: string | null | undefined;
};
export type CoachClientsListScreenRefetchQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CoachClientsListScreen_root">;
};
export type CoachClientsListScreenRefetchQuery = {
  response: CoachClientsListScreenRefetchQuery$data;
  variables: CoachClientsListScreenRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": 10,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": true,
    "kind": "LocalArgument",
    "name": "includeAllClients"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "query"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "sort"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "status"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "tagId"
  }
],
v1 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v2 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v3 = {
  "kind": "Variable",
  "name": "query",
  "variableName": "query"
},
v4 = {
  "kind": "Variable",
  "name": "status",
  "variableName": "status"
},
v5 = {
  "kind": "Variable",
  "name": "tagId",
  "variableName": "tagId"
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "current",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v10 = [
  (v8/*: any*/),
  (v9/*: any*/)
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "clientStatus",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "photoURL",
  "storageKey": null
},
v16 = [
  {
    "kind": "Literal",
    "name": "format",
    "value": "fromNow"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CoachClientsListScreenRefetchQuery",
    "selections": [
      {
        "args": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "kind": "Variable",
            "name": "includeAllClients",
            "variableName": "includeAllClients"
          },
          (v3/*: any*/),
          {
            "kind": "Variable",
            "name": "sort",
            "variableName": "sort"
          },
          (v4/*: any*/),
          (v5/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "CoachClientsListScreen_root"
      }
    ],
    "type": "Root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CoachClientsListScreenRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "TagConnection",
        "kind": "LinkedField",
        "name": "tags",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TagEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Tag",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v7/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "kind": "Variable",
            "name": "orderBy",
            "variableName": "sort"
          },
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/)
        ],
        "concreteType": "ClientConnection",
        "kind": "LinkedField",
        "name": "clients",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageCursors",
            "kind": "LinkedField",
            "name": "pageCursors",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PageCursor",
                "kind": "LinkedField",
                "name": "previous",
                "plural": false,
                "selections": (v10/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageCursor",
                "kind": "LinkedField",
                "name": "around",
                "plural": true,
                "selections": [
                  (v8/*: any*/),
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "page",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageCursor",
                "kind": "LinkedField",
                "name": "next",
                "plural": false,
                "selections": (v10/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ClientEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              (v9/*: any*/),
              {
                "alias": "client",
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Tag",
                    "kind": "LinkedField",
                    "name": "tag",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  {
                    "alias": null,
                    "args": (v16/*: any*/),
                    "kind": "ScalarField",
                    "name": "lastLoginAt",
                    "storageKey": "lastLoginAt(format:\"fromNow\")"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endPrograms",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Invite",
                    "kind": "LinkedField",
                    "name": "invite",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "client",
                        "plural": false,
                        "selections": [
                          (v14/*: any*/),
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v6/*: any*/),
                      (v11/*: any*/),
                      {
                        "alias": "invitedAt",
                        "args": (v16/*: any*/),
                        "kind": "ScalarField",
                        "name": "updatedAt",
                        "storageKey": "updatedAt(format:\"fromNow\")"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "condition": "includeAllClients",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "allClients",
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 9999
              },
              (v4/*: any*/)
            ],
            "concreteType": "ClientConnection",
            "kind": "LinkedField",
            "name": "clients",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ClientEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": "client",
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v15/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "InviteCode",
        "kind": "LinkedField",
        "name": "inviteCode",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5425dcdb94bc4f3b4c291ffcfa28b446",
    "id": null,
    "metadata": {},
    "name": "CoachClientsListScreenRefetchQuery",
    "operationKind": "query",
    "text": "query CoachClientsListScreenRefetchQuery(\n  $after: String\n  $first: Int = 10\n  $includeAllClients: Boolean = true\n  $query: String\n  $sort: ClientSortBy!\n  $status: [ClientStatusFilter!]\n  $tagId: ID = null\n) {\n  ...CoachClientsListScreen_root_1xS4VL\n}\n\nfragment ClientCard_client on User {\n  id\n  email\n  username\n  tag {\n    title\n    id\n  }\n  displayName\n  clientStatus\n  photoURL\n  lastLoginAt(format: \"fromNow\")\n  endPrograms\n}\n\nfragment ClientMenu_client on User {\n  id\n  clientStatus\n}\n\nfragment ClientPendingCard_invite on Invite {\n  id\n  email\n  invitedAt: updatedAt(format: \"fromNow\")\n  client {\n    clientStatus\n    id\n  }\n}\n\nfragment CoachClientsListScreen_root_1xS4VL on Root {\n  tags {\n    edges {\n      node {\n        id\n        title\n      }\n    }\n  }\n  clients(first: $first, after: $after, query: $query, status: $status, orderBy: $sort, tagId: $tagId) {\n    pageCursors {\n      ...ConnectionPagination_pageCursors\n    }\n    totalCount\n    edges {\n      cursor\n      client: node {\n        id\n        ...ClientCard_client\n        ...ClientMenu_client\n        ...CoachMessageClientsDialog_clients\n        invite {\n          client {\n            clientStatus\n            id\n          }\n          ...ClientPendingCard_invite\n          id\n        }\n      }\n    }\n  }\n  allClients: clients(first: 9999, status: $status) @include(if: $includeAllClients) {\n    edges {\n      client: node {\n        id\n        ...CoachMessageClientsDialog_clients\n      }\n    }\n  }\n  inviteCode {\n    ...InviteDialog_inviteCode\n    id\n  }\n}\n\nfragment CoachMessageClientsDialog_clients on User {\n  id\n  username\n  displayName\n  photoURL\n}\n\nfragment ConnectionPagination_pageCursors on PageCursors {\n  previous {\n    current\n    cursor\n  }\n  around {\n    current\n    cursor\n    page\n  }\n  next {\n    current\n    cursor\n  }\n}\n\nfragment InviteCodePreviewDialog_inviteCode on InviteCode {\n  code\n}\n\nfragment InviteDialog_inviteCode on InviteCode {\n  ...InviteLinkSettings_inviteCode\n  ...InviteCodePreviewDialog_inviteCode\n  code\n}\n\nfragment InviteLinkSettings_inviteCode on InviteCode {\n  id\n  code\n}\n"
  }
};
})();

(node as any).hash = "2d10f74d1a6b312cf759d058a690d7c8";

export default node;
